import { z } from 'zod';
import { BaseUserDTOSchema } from "./users.dto.js";
export const CreateUserInputDTOSchema = BaseUserDTOSchema.pick({
    name: true,
    email: true,
    userType: true,
}).extend({
    password: z.string().min(8).max(100),
    companyId: z.string().uuid().optional(),
});
export const CreateUserOutputDTOSchema = BaseUserDTOSchema;
//# sourceMappingURL=create-user.dto.js.map